import { createWebHistory, createRouter } from "vue-router";
import StudiesComponent from './../components/Studies.vue';
import VersionsComponent from './../components/Versions.vue';
import CostWalkComponent from './../components/CostWalk.vue';
import CompareComponent from './../components/Compare.vue';
import BOMComponent from './../components/BOM.vue';
import GSMComponent from './../components/GSM.vue';
import ComponentWalk from './../components/ComponentWalk.vue';
import BusinessCaseComparison from './../components/BusinessCaseComparison.vue';
import SaleableComparison from './../components/SaleableComparison.vue';
import CalculationResults from './../components/CalculationResult.vue';
import ProfitAndLossComponent from './../components/ProfitAndLoss.vue';
import ProfitAndLossComparisonComponent from './../components/ProfitAndLossComparison.vue';
import FinancialDashboardComponent from './../components/FinancialDashboard.vue';
import MECostComponent from './../components/MECost.vue';


const routes = [
    {
        path: "/",
        name: "Studies",
        component: StudiesComponent
    },
    {
        path: "/studies/:id",
        name: "Versions",
        component: VersionsComponent
    },
    {
        path: "/studies/:id/version/:ver",
        name: "CostWalk",
        component: CostWalkComponent
    },
    {
        path: "/studies/:id/version/:ver/profitAndLoss",
        name: "ProfitAndLoss",
        component: ProfitAndLossComponent
    },
    {
        path: "/studies/:id/version/:ver/financialDashboard",
        name: "FinancialDashboard",
        component: FinancialDashboardComponent
    },
    {
        path: "/studies/:id/version/:ver/calculations",
        name: "CaclualtionResults",
        component: CalculationResults
    },
    {
        path: "/compare",
        name: "Compare",
        component: CompareComponent
    },
    {
        path: "/studies/:id/version/:ver/bom",
        name: "BOM",
        component: BOMComponent
    },
    {
        path: "/walk/component",
        name: "ComponentWalk",
        component: ComponentWalk,
        props: route => (route.query)
    },
    {
        path: "/compare/businesscase",
        name: "BusinessCaseComparison",
        component: BusinessCaseComparison,
        props: route => (route.query)
    },
    {
        path: "/compare/saleable",
        name: "SaleableComparison",
        component: SaleableComparison,
        props: route => (route.query)
    },
    {
        path: "/compare/profitAndLoss",
        name: "ProfitAndLossComparison",
        component: ProfitAndLossComparisonComponent,
        props: route => (route.query)
    },
    {
        path: "/studies/:id/version/:ver/gsm",
        name: "GSM",
        component: GSMComponent
    },
    {
        path: "/studies/:id/version/:ver/meCost",
        name: "MECost",
        component: MECostComponent
    }
];

const router = createRouter({
    routes,
    history: createWebHistory(),
});

export default router;